import constants from '../../_constants/charges.constants';
import service from '../../../services/charges.service';

export const fetchChargesSummary = () => {
  return async dispatch => {
    dispatch(request());

    try {
      const response = await service.getSummary();

      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: constants.CHARGES_SUMMARY_REQUEST };
  }

  function success(data) {
    return { type: constants.CHARGES_SUMMARY_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.CHARGES_SUMMARY_FAILURE, payload: error };
  }
};

export default fetchChargesSummary;
